const disclaimerConfig = {
  storageKey: "metadata_disclaimer_accepted",

  tdisLogo: "/assets/tdislogo-white.png",
  idrtLogo: "/assets/IDRT_logo.png",
  tamuLogo: "/assets/tamulogo-white.png",

  // Footer on Left Panel
  footerPoweredBy: "Powered by TDIS",

  // Right Panel Content
  welcomeText: "Welcome to the",
  welcomeTitle: "TDISMeta - Metadata Management Tool",

  informationText:
    "TDISMeta is a metadata management tool that supports creation, review, and management of model metadata for the Regional Floodplain Studies (RBFS) effort. It helps teams document and organize model packages for discovery and reuse across emergency management agencies and communities.",

  // Disclaimer Section
  disclaimerTitle: "Disclaimer",
  disclaimerText: [
    "By accessing this website or its data, users release Texas A&M University (TAMU) and the Institute for Disaster Resilient Texas (IDRT) from all liability arising from its use. The Metadata Management Tool (TDISMeta) is provided for noncommercial, informational, and planning purposes only. Although efforts are made to ensure accuracy, TAMU and IDRT make no warranties, express or implied, regarding the completeness, reliability, or suitability of the information provided.",
    "Users are responsible for independently verifying all information before making decisions. TAMU and IDRT do not guarantee continuous or error-free access and may modify or discontinue the tool at any time. The website may include third-party data or links, for which TAMU and IDRT assume no responsibility.",
    "Use of this tool does not constitute endorsement by any federal, state, or local agency. By using this site, users agree to these terms.",
  ],

  // Accept Button
  acceptButtonText: "I ACCEPT",
};

export default disclaimerConfig;
